import { useSelector } from 'react-redux';
import { ThemeProvider as MuiThemeProvider } from '@emotion/react';
import themeCreator from '@mvf/external-components/Themes/themeCreator';
import React from 'react';

const ThemeProvider = ({ children }) => {
  const { fontOverride } = useSelector((store) => store.optionalFormConfig);
  const { palette } = useSelector((store) => store.theme);

  const fontFamily = fontOverride?.fontFamily
    ? fontOverride?.fontFamily
    : "'Arial', sans-serif";

  const theme = themeCreator(palette, fontFamily);

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
